import { useSession } from '@common/authorization/context/Session';
import { useSelfServiceData } from '@selfservice/utils/useSelfServiceData';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import SelfServiceLayout from './SelfServiceLayout';

export const SelfServiceContainer = () => {
  const { t } = useTranslation();
  document.title = t('self-service.browser-title');

  const { userInfo } = useSession();

  const { data } = useSelfServiceData();

  const logoUrl = data?.orgInfo?.logoUrl || '';
  const username = userInfo?.userDisplayName || userInfo?.userUpn || userInfo?.email || '';

  return (
    <SelfServiceLayout logoUrl={logoUrl} username={username} email={username}>
      <Outlet />
    </SelfServiceLayout>  
  );
};
